import { useRef, useState } from 'react';
import { styled } from '@mui/material/styles';
import ButtonGroup from '@mui/material/ButtonGroup';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import MenuItem from '@mui/material/MenuItem';
import Button from '@components/Button';
import { PopperMenu } from '@components/Popper';
import Tooltip from '@components/Tooltip';
import { Typography } from '@components/Typography';

const StyledButtonGroup = styled(ButtonGroup)({
    '& .MuiButtonGroup-firstButton:hover': {
        borderRightColor: 'transparent',
    },
    '& .MuiButtonGroup-lastButton': {
        padding: '8px 0',
    },
});

const SplitButton = ({ className, sx, variant, options = [], disabled }) => {
    const [open, setOpen] = useState(false);
    const anchorRef = useRef(null);

    const onClick = () => {
        if (!options[0]?.disabled) options[0]?.onClick();
    };

    const handleMenuItemClick = index => {
        setOpen(false);
        options[index]?.onClick();
    };

    const handleToggle = () => {
        setOpen(prevOpen => !prevOpen);
    };

    const handleClose = event => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }
        setOpen(false);
    };

    return (
        <>
            <StyledButtonGroup ref={anchorRef} disabled={disabled} className={className} sx={sx}>
                <Button variant={variant} onClick={onClick} disabled={options[0]?.disabled}>
                    {options[0]?.text || ''}
                </Button>
                <Button variant={variant} size="small" onClick={handleToggle}>
                    <ArrowDropDownIcon />
                </Button>
            </StyledButtonGroup>
            <ClickAwayListener onClickAway={handleClose}>
                <PopperMenu
                    open={open}
                    anchorEl={anchorRef.current}
                    placement="bottom-end"
                    style={{ minWidth: anchorRef.current?.offsetWidth }}
                >
                    {options.map((item, index) => {
                        const menuItem = (
                            <MenuItem
                                key={item.text}
                                onClick={item.disabled ? null : () => handleMenuItemClick(index)}
                                disabled={item.disabled}
                                sx={item.disabled ? { '&.Mui-disabled': { pointerEvents: 'auto' } } : null}
                            >
                                <Typography variant="body2">{item.text}</Typography>
                            </MenuItem>
                        );
                        return item.tooltip ? (
                            <Tooltip key={item.text} title={item.tooltip} placement="left">
                                {menuItem}
                            </Tooltip>
                        ) : (
                            menuItem
                        );
                    })}
                </PopperMenu>
            </ClickAwayListener>
        </>
    );
};

export default SplitButton;
